import { Loadable } from '../Loadable';

export const AsyncAccountInfo = Loadable(() => import('./AccountInfo'));
export const AsyncEditAccount = Loadable(() => import('./EditAccount'));
